<script setup lang="ts">
const { t } = useI18n()
const cartStore = useCartStore()
</script>

<template>
  <RBaseModal
    class="!w-[490px] px-6 pb-8 pt-4 shadow-xl"
    :is-open="cartStore.isCartLimitReachedModalVisible"
    is-closeable
    is-closeable-on-esc
    @close="cartStore.isCartLimitReachedModalVisible = false"
  >
    <div class="flex flex-col gap-8 text-center">
      <h1 class="primary-text text-2xl font-bold">
        {{ t('components.cartLimitModal.title') }}
      </h1>

      <p class="text-lg font-bold text-gray-400">
        {{ t('components.cartLimitModal.text') }}
      </p>

      <div class="flex items-center justify-center">
        <RBaseButton
          :full-width="false"
          color="primary"
          class="min-w-[160px] px-6"
          @click="cartStore.isCartLimitReachedModalVisible = false"
        >
          {{ t('components.cartLimitModal.confirmButton') }}
        </RBaseButton>
      </div>
    </div>
  </RBaseModal>
</template>
